export function booleanYesNoIconFilter(value: boolean) {
  return value ? 'mdi-check' : 'mdi-close';
}
